var _path, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFitness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.26,127.24c-19.55,8.47-39,21.56-45.91,41.71-2.62,7.66-3.29,16-7.07,23.17-3.62,6.87-9.77,12-16,16.61a207.84,207.84,0,0,1-54.7,28.76c-12.26,4.26-24.93,7.37-36.85,12.5s-23.29,12.57-30.32,23.47c-5.16,8-7.54,18.9-2.4,26.92s15.79,10.36,25.33,11.41c30.5,3.34,61.32,1.17,91.93-1,24.7-1.76,49.63-3.55,73.36-10.63,28-8.34,53.27-23.71,78.2-38.92,10.38-6.34,21.86-14.3,23.26-26.39,1.48-12.75-9.14-24-9.92-36.83-.59-9.69,4.56-18.84,10.72-26.36s13.51-14.09,18.7-22.31,7.93-18.86,3.85-27.68c-7.6-16.41-37.51-11.6-51.72-10.87A204.21,204.21,0,0,0,280.26,127.24Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.26,127.24c-19.55,8.47-39,21.56-45.91,41.71-2.62,7.66-3.29,16-7.07,23.17-3.62,6.87-9.77,12-16,16.61a207.84,207.84,0,0,1-54.7,28.76c-12.26,4.26-24.93,7.37-36.85,12.5s-23.29,12.57-30.32,23.47c-5.16,8-7.54,18.9-2.4,26.92s15.79,10.36,25.33,11.41c30.5,3.34,61.32,1.17,91.93-1,24.7-1.76,49.63-3.55,73.36-10.63,28-8.34,53.27-23.71,78.2-38.92,10.38-6.34,21.86-14.3,23.26-26.39,1.48-12.75-9.14-24-9.92-36.83-.59-9.69,4.56-18.84,10.72-26.36s13.51-14.09,18.7-22.31,7.93-18.86,3.85-27.68c-7.6-16.41-37.51-11.6-51.72-10.87A204.21,204.21,0,0,0,280.26,127.24Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 415.69,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Time--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.79,95.47c0-2.77,1.54-4.34,3.6-4.34s3.6,1.57,3.6,4.34-1.52,4.34-3.6,4.34S305.79,98.24,305.79,95.47Zm5.24,0c0-1.91-.67-2.7-1.64-2.7s-1.63.79-1.63,2.7.67,2.7,1.63,2.7S311,97.38,311,95.47Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.87,97a2.88,2.88,0,0,1-3.18,2.79c-2.31,0-3.75-1.45-3.75-4.16,0-2.9,1.75-4.52,4.28-4.52a4.46,4.46,0,0,1,2.34.58l-.72,1.42a2.79,2.79,0,0,0-1.57-.42,2.23,2.23,0,0,0-2.36,2.44A2.84,2.84,0,0,1,318,94.4,2.67,2.67,0,0,1,320.87,97Zm-1.88.09a1.26,1.26,0,0,0-1.43-1.25,1.31,1.31,0,0,0-1.45,1.25c0,.72.54,1.25,1.48,1.25A1.26,1.26,0,0,0,319,97.11Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.64,98.59a1.17,1.17,0,0,1,2.33,0,1.17,1.17,0,1,1-2.33,0Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.24,98.09v1.58H324.9V98.41l3.23-3.06c.75-.71.88-1.14.88-1.55,0-.66-.46-1-1.34-1a2.07,2.07,0,0,0-1.74.84l-1.42-.91a3.91,3.91,0,0,1,3.34-1.56c1.87,0,3.11,1,3.11,2.48a3.32,3.32,0,0,1-1.4,2.65l-1.93,1.83Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.25,97.1c0,1.42-1.09,2.71-3.48,2.71a5.73,5.73,0,0,1-3.2-.9l.75-1.48a4.1,4.1,0,0,0,2.4.75c1,0,1.57-.39,1.57-1.08s-.46-1-1.57-1h-.88V94.79l1.72-2H332V91.27h5.88v1.26L336,94.69A2.39,2.39,0,0,1,338.25,97.1Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.09,98.59a1.17,1.17,0,0,1,2.33,0,1.17,1.17,0,1,1-2.33,0Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.34,91.27v8.4H343.4V92.83h-1.68V91.27Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.84,97.23c0,1.59-1.42,2.58-3.55,2.58s-3.53-1-3.53-2.58a2.15,2.15,0,0,1,1.27-2,1.94,1.94,0,0,1-1-1.72c0-1.48,1.32-2.4,3.23-2.4s3.25.92,3.25,2.4a1.93,1.93,0,0,1-1,1.72A2.14,2.14,0,0,1,353.84,97.23Zm-2-.06c0-.74-.61-1.2-1.58-1.2s-1.56.46-1.56,1.2.6,1.22,1.56,1.22S351.87,97.92,351.87,97.17ZM349,93.61c0,.64.51,1,1.3,1s1.32-.39,1.32-1-.53-1-1.32-1S349,93,349,93.61Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.54,102.6a.87.87,0,0,1-.63-.28l-6-6.69a.84.84,0,0,1,1.25-1.12l6,6.69a.84.84,0,0,1-.06,1.18A.81.81,0,0,1,289.54,102.6Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.81,82.42V81.36h-3.42V82.5a13.7,13.7,0,0,0,2,27.27,13.71,13.71,0,0,0,1.46-27.35Zm-1.46,25.67a12,12,0,1,1,12-12A12.05,12.05,0,0,1,283.35,108.09Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.82,
    y: 78.59,
    width: 4.56,
    height: 2.32,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.54,102.6a.87.87,0,0,1-.63-.28l-6-6.69a.84.84,0,0,1,1.25-1.12l6,6.69a.84.84,0,0,1-.06,1.18A.81.81,0,0,1,289.54,102.6Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.81,82.42V81.36h-3.42V82.5a13.7,13.7,0,0,0,2,27.27,13.71,13.71,0,0,0,1.46-27.35Zm-1.46,25.67a12,12,0,1,1,12-12A12.05,12.05,0,0,1,283.35,108.09Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.82,
    y: 78.59,
    width: 4.56,
    height: 2.32,
    style: {
      fill: "#19A49C"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.21,
    y: 189.8,
    width: 7.24,
    height: 0.75,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.97,
    y: 189.8,
    width: 18.67,
    height: 0.75,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.09,330.29h-7.42v-.75c12.4,0,25.09,0,37.72-.2v.75C206.29,330.22,196.12,330.29,186.09,330.29Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.57,330.24c-5.33,0-10.78-.08-16.19-.16v-.75c5.41.08,10.85.13,16.18.16Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.88,
    y: 329.33,
    width: 6.06,
    height: 0.75,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.9,
    y: 165.2,
    width: 24.03,
    height: 0.75,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.7,
    y: 165.2,
    width: 3.1,
    height: 0.75,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.34,
    y: 341.39,
    width: 17.29,
    height: 0.75,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.19,
    y: 341.39,
    width: 9.74,
    height: 0.75,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.14,183.59c-14,1.24-33.25,7.41-32.8,10.56L203.2,219.22l-6.31,2.34s13.21-32.69,16.64-38.06c2.4-3.75,25.56-11.46,37.67-15.8,5.23-1.88,10,1.69,11.52,4.71C262.72,172.41,267.74,182.57,256.14,183.59Z",
    style: {
      fill: "#e29471"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.2,219.22l-.46,5.46a6.53,6.53,0,0,1-2.21,4.37l-4.89,4.29a1.58,1.58,0,0,1-2.06,0l-3.32-2.82a1.57,1.57,0,0,1-.3-2.07l3.73-5.65,4.5-6S203.37,217.12,203.2,219.22Z",
    style: {
      fill: "#e29471"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.64,363.93l-27.91,10.94c-.81-.7-5.56-10.09-5.56-10.09l24.75-11.43Z",
    style: {
      fill: "#e29471"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.64,377.46a.31.31,0,0,1,.12-.32.32.32,0,0,1,.35,0c.17.12,4.37,2.94,4.78,5.08a1.48,1.48,0,0,1-.19,1.16,1.11,1.11,0,0,1-1.16.6c-.86-.11-1.75-1.41-2.46-2.87A20.07,20.07,0,0,1,153.64,377.46Zm4.51,4.35a13.45,13.45,0,0,0-3.64-3.65c.74,2.23,2.18,5.08,3.17,5.25.13,0,.32,0,.56-.36a.87.87,0,0,0,.12-.7,2.79,2.79,0,0,0-.2-.55Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.69,377.27a.28.28,0,0,1,.23-.2c.14,0,3.31-1.25,5.22-.4a2.2,2.2,0,0,1,1.12,1.31,1.1,1.1,0,0,1-.26,1.37c-1.17.85-4.94-.64-6.23-1.7l-.08-.1Zm5.17,0a7,7,0,0,0-4.22.23c1.54,1,4.41,1.92,5.06,1.36.06-.05.23-.17.05-.66l-.12-.15A1.54,1.54,0,0,0,158.86,377.24Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.87,374.69l-1.74-1.51a8.94,8.94,0,0,1-3.08-6.68l0-3a1.07,1.07,0,0,0-1.22-.61l-10.22,1.8c-1,.26-1.32,2.51-1.27,2.62,2.29,7.13,8.35,22,10.54,26.79s7.25,3.27,6.78,1.1c-2.09-9.71-.94-14.26.31-18.23A3.12,3.12,0,0,0,154.87,374.69Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.26,357.35l8.66-4,8.72,10.58-12.77,5-2.06-2.51a9.81,9.81,0,0,1-2.19-5.29Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M213.46,256.23a27.94,27.94,0,0,0-1.91,6.34c-2.24,11.47-5.36,50.38-7.39,65.17a8.74,8.74,0,0,1-5.33,6.65c-8.07,3.8-13.31,5-31.51,19.9,2.19,4.66,4.28,7.94,6.27,13.41,0,0,35.08-13.48,43.1-20.08,11.81-9.72,26.19-60.8,30.37-74,2.37-7.48,5.11-16.43.74-22.89C245.34,247.11,221.36,236.09,213.46,256.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,169.82c2.65,3,3.89,5,3.09,13.76-1.57,17-.53,44.06-1.13,48.23C260,238.17,224.5,239,218,233.14l-12.89-52a12.45,12.45,0,0,1,10.27-15.32C218.33,165.37,250.94,160.79,259,169.82Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,231.81h0a66.52,66.52,0,0,1,.7,17.42,39.9,39.9,0,0,0,8.32,28h0s-46.37-6.75-57.35-18.77L218,233.14A168.35,168.35,0,0,0,261,231.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.78,152.71l-.76-.62s0,0,0,0c-2.22-2.81-3.08-6-4-11-.25-1.29-.5-2.68-.78-4.22a13.5,13.5,0,0,1,.2-6.16,14.22,14.22,0,0,1,1.22-3c1.19,4.44,1.36,9.05,1.77,13.6A39.71,39.71,0,0,0,228.78,152.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.77,147.35c.56,5.12.95,12.29-1.81,16.35a4.17,4.17,0,0,0-.13,4.68c1.63,2.47,5.37,6.18,14,10.45,2.53-3.12,3.45-5.66,3.62-7.59a5.38,5.38,0,0,0-3.16-5.29c-4.14-1.94-3.69-4.42-2.41-8.29Z",
    style: {
      fill: "#e29471"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.86,151.51l5.91,6.15a18.66,18.66,0,0,0-.8,3.13c-2.39-.55-6-3-6.32-5.68A8,8,0,0,1,233.86,151.51Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.46,147.25a11.92,11.92,0,0,1-11.76,10.89h-.08a13.14,13.14,0,0,1-6.56-1.72A14.18,14.18,0,0,1,231,155c-.28-.22-.54-.45-.79-.66a17.17,17.17,0,0,1-2.14-2.25s0,0,0,0c-2.22-2.81-3.08-6-4-11-.25-1.29-.5-2.68-.78-4.22a13.5,13.5,0,0,1,.2-6.16,14.22,14.22,0,0,1,1.22-3,11,11,0,0,1,.77-1.23,13,13,0,0,1,14.15-5.14c4.46,1.19,7.53,4.81,9.47,9.25.19.44.37.89.54,1.34A35.51,35.51,0,0,1,251.46,147.25Z",
    style: {
      fill: "#e29471"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.71,137.45c.1.79.59,1.39,1.09,1.33s.85-.77.76-1.56-.6-1.38-1.1-1.32S238.66,136.7,238.71,137.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.48,136.35c.11.81.6,1.39,1.1,1.33s.85-.77.75-1.56-.59-1.38-1.09-1.31S247.39,135.56,247.48,136.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,138.13a21.45,21.45,0,0,0,3.41,4.71,3.41,3.41,0,0,1-2.72.88Z",
    style: {
      fill: "#ea573f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,136.11a.46.46,0,0,0,.45-.31,5.45,5.45,0,0,1,3.37-2.81.49.49,0,0,0,.33-.58.45.45,0,0,0-.55-.33h0a6.25,6.25,0,0,0-4,3.4.46.46,0,0,0,.28.59h0A.32.32,0,0,0,235,136.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.61,131.89a.5.5,0,0,0,.42-.22.48.48,0,0,0-.15-.65,4.45,4.45,0,0,0-4.22-.47.45.45,0,0,0-.23.59s0,0,0,0a.45.45,0,0,0,.6.23h0a3.59,3.59,0,0,1,3.3.41A.5.5,0,0,0,249.61,131.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.78,143.74c-.41.54-1.73-2.34-2.4-2.48a9.73,9.73,0,0,0-2.41-.19c-.25-1.29-.5-2.68-.78-4.22a13.5,13.5,0,0,1,.2-6.16,14.22,14.22,0,0,1,1.22-3q-.09-.37-.21-.75h0a6.24,6.24,0,0,1,1-.48,4.59,4.59,0,0,1,2.43-.25,3.9,3.9,0,0,1,2.72,2.33C227.17,134.81,230.05,142.08,228.78,143.74Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,152.07c-3.71-3.14-7-7-8.48-11.66a15.3,15.3,0,0,1,3.95-15c.3-.29.8-.16,1.18,0s-.55.48-.44.8.13.45.19.66.15.5.21.75a14.22,14.22,0,0,0-1.22,3,13.5,13.5,0,0,0-.2,6.16c.28,1.54.53,2.93.78,4.22C224.92,146.05,225.78,149.26,228,152.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.51,144.66a7,7,0,0,0,4,3.54c2.31.76,3.58-1.31,3-3.6-.52-2.06-2.32-4.93-4.68-4.74a3.18,3.18,0,0,0-2.31,4.8Z",
    style: {
      fill: "#e29471"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.26,377.92l2.31,29.89c-.91.57-10.88,5.22-11.28,2.37-1.2-8.71-3.69-27-3.69-27Z",
    style: {
      fill: "#e29471"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.31,407.7a.31.31,0,0,1-.27-.21.3.3,0,0,1,.1-.33c.16-.14,4.09-3.32,6.25-3.1a1.48,1.48,0,0,1,1.06.53,1.1,1.1,0,0,1,.23,1.28c-.35.8-1.85,1.27-3.46,1.52A20.49,20.49,0,0,1,335.31,407.7Zm5.48-3a13.43,13.43,0,0,0-4.56,2.41c2.35-.06,5.5-.59,5.95-1.49.05-.13.09-.31-.18-.65a.92.92,0,0,0-.63-.32,2.92,2.92,0,0,0-.59,0Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.14,407.59a.27.27,0,0,1-.12-.27c0-.15-.23-3.54,1.14-5.11a2.2,2.2,0,0,1,1.58-.69,1.1,1.1,0,0,1,1.24.65c.47,1.36-2.06,4.54-3.45,5.46l-.12.05Zm1.48-4.94a7,7,0,0,0-1,4.09c1.38-1.18,3.13-3.66,2.78-4.43,0-.07-.09-.27-.62-.25l-.17.08A1.5,1.5,0,0,0,336.62,402.65Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,405.72l-12.12,1.35a1.07,1.07,0,0,0-.95,1l-1.25,10.3c-.06,1,2,2,2.12,2,7.49-.11,23.46-1.56,28.71-2.26s5.24-6,3-6.16c-9.9-.84-13.92-3.26-17.35-5.62A3,3,0,0,0,333,405.72Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "318.84 392.22 317.6 383.17 330.26 377.92 331.06 390.16 318.84 392.22"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M241.06,266.35c6.36,11.23,37.28,37.43,52.2,59.82,4.07,6.12,13.9,48.27,23.35,60.21l15-1.38c5.43-10.56-7.39-65.16-7.39-65.16-4.51-24-31.26-50.7-60.75-77.75-4.95-4.53-12.31-5.9-19.72-1.49C242.37,241.4,234.9,255.45,241.06,266.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.75,248.79c-1.18.27-2.41-.47-3.31-2a11.42,11.42,0,0,1-1.56-5.25l-3.27,4.24a2.85,2.85,0,0,1-2.41,1.47,1.74,1.74,0,0,1-1.23-.73,3.3,3.3,0,0,1-.44-2.52,6.46,6.46,0,0,1,7.41-4.83l-.12-.43,1-.27.06.24.22-.28,0,.42a4.33,4.33,0,0,1,4.1,1.47,7.74,7.74,0,0,1,1.61,4.62c.1,1.53-.36,3.46-1.95,3.84Zm-3.84-8.88,0,.2a10.47,10.47,0,0,0,1.39,6.19c.52.88,1.34,1.74,2.26,1.53,1.07-.26,1.26-1.9,1.2-2.83a6.73,6.73,0,0,0-1.37-4,3.47,3.47,0,0,0-2.8-1.21l-.64.16Zm-3.28.25a5.39,5.39,0,0,0-1.8.77,5.23,5.23,0,0,0-2.34,3.27,2.38,2.38,0,0,0,.27,1.74.8.8,0,0,0,.55.34c.56.06,1.08-.52,1.53-1.1l3.83-5-.18,0-.05-.18A4.81,4.81,0,0,0,240.63,240.16Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.14,262.32l-.83-.52A45.37,45.37,0,0,0,242.13,240l1,0A46.37,46.37,0,0,1,236.14,262.32Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.56,262.13l-1,.12a34.07,34.07,0,0,0-11.51-21.51l.64-.74A35.07,35.07,0,0,1,255.56,262.13Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,357.74l-.45-.87c11-5.75,39.64-22,39.64-28.09,0-12.49,12.22-94.59,12.34-95.41l1,.14c-.12.83-12.32,82.86-12.32,95.27C209.21,336.68,170.67,356.89,169,357.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.57,172.66c1.32-4,9.59-4.76,12.2-1.6,11.25,13.65,23.74,26.35,23.74,26.35l31.35-6.49,5.09,4.41s-32.37,16.21-38.75,16.22c-6.84,0-23.32-15.89-32-25.42C203.57,179.88,207.57,172.66,207.57,172.66Z",
    style: {
      fill: "#e29471"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.86,190.92l5-2.22a6.52,6.52,0,0,1,4.89-.17l6.11,2.23a1.57,1.57,0,0,1,1,1.79l-.88,4.27a1.56,1.56,0,0,1-1.67,1.26l-6.75-.55-7.41-1.07S272.94,191.77,274.86,190.92Z",
    style: {
      fill: "#e29471"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.9 197.96 275.69 199.55 271.81 191.32 274.24 190.18 277.9 197.96",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.92,190h4a1,1,0,0,1,1,1v.75a0,0,0,0,1,0,0h-6a0,0,0,0,1,0,0v-.75A1,1,0,0,1,270.92,190Z",
    transform: "translate(-55.3 134.54) rotate(-25.23)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.77,136c1.14-3.8,4.74-6.39,8.46-7.75s7.73-1.81,11.51-3c2.51-.8,5.27-2.38,5.52-5a5.18,5.18,0,0,0-2-4.23,15.51,15.51,0,0,0-4.26-2.3,6.94,6.94,0,0,0-3.58-.76,2.39,2.39,0,0,0-2.14,2.53c-3.2-2-8-1.47-11,.83-2,1.55-3.33,4.58-1.82,6.63-1.74-.88-4.58.12-5.56,1.8a4,4,0,0,0,1.19,5.16c-2.65-.11-5.1,2.79-4.1,5.24S220,138.53,220.77,136Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.82,146.53a34.41,34.41,0,0,0-1.28,4.83l-.89,0c-4-.15-5.78-1.53-6.57-3a5.13,5.13,0,0,1-.55-2.38,4.92,4.92,0,0,1,.17-1.38c2.06,1.34,5.77,1.76,7.76,1.9C245.29,146.53,245.82,146.53,245.82,146.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.46,146.46l-.42,1.42c-3.75-.15-6.37-.76-7.51-1.94a4.92,4.92,0,0,1,.17-1.38C238.76,145.9,242.47,146.32,244.46,146.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.65,151.34c-4-.15-5.78-1.53-6.57-3a12.84,12.84,0,0,1,4.39,1A4.81,4.81,0,0,1,243.65,151.34Z",
    style: {
      fill: "#de5753"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitness);
export default __webpack_public_path__ + "static/media/fitness.562502a119d03e0df730b0c6200fd0e8.svg";
export { ForwardRef as ReactComponent };